'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gdprConsentToProcessEnabled = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _getMessage = require('./getMessage');

var _getGdprConsentToProcessEnabled = require('../message/getGdprConsentToProcessEnabled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gdprConsentToProcessEnabled = exports.gdprConsentToProcessEnabled = (0, _pipe2.default)(_getMessage.getMessage, _getGdprConsentToProcessEnabled.getGdprConsentToProcessEnabled);